<div class="d-flex align-items-center">
  <div class="container">
    <div class="d-flex justify-content-center">
      <div class="spinner-border text-light mr-4" role="status">
        <span class="sr-only">Loading...</span>
      </div>
      <img width="165" height="40" src="https://publico.transbank.cl/documents/121605/0/logo.png" alt="Logo Transbank">
    </div>
    <label class="from-control">Redireccionando...</label>
  </div>
</div>